import React, { Component } from 'react'
import { connect } from 'react-redux'
import '@/companys/eif/assets/styles/components/security-tips/security-tips.scss'

class SecurityTips extends Component {
  render() {
    const { language } = this.props
    return (
      <div className='login-security-tips'>
        <span>{language.tradinglogon_security_remembers}</span>
        <span>{language.securityI}</span>
        <span>{language.securityII}</span>
      </div>
    )
  }
}

export default connect(state => ({ language: state.app.language }))(SecurityTips)
